import axios from './axios';
import { getConfig } from '../utils/sessionStorageUtils';

export const getModels = async (url: string) => {
  try {
    const result = await axios.get(`/Models/${url || ''}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getModel = async (url: string) => {
  try {
    const result = await axios.get(url, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const addModel = async (model: {
  name: string;
  brandId: string;
  stringImage: string | null;
  urlSlug: string | null;
}) => {
  try {
    const result = await axios.post('/Models', model, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const updateModel = async (model: {
  id: string;
  name: string;
  brandId: string;
  stringImage: string | null;
  urlSlug: string | null;
}) => {
  try {
    const result = await axios.put(`/Models/${model.id}`, model, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const deleteModel = async (id: string) => {
  try {
    const result = await axios.delete(`/Models/${id}`, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};
